import { Grid, TextField } from "@mui/material";

// The form fields for the Create App form
export default function CreateAppForm(props: any) {
  const { formik } = props;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          sx={{ mt: "2%" }}
          name="appName"
          label="App Name"
          placeholder="Enter App Name"
          value={formik.values.appName}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.appName)}
          helperText={
            formik.errors.appName ||
            `${formik.values.appName.trim().length}/100`
          }
          required
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          name="techStack"
          label="Tech Stack"
          placeholder="Enter Tech Stack"
          onChange={formik.handleChange}
          value={formik.values.techStack}
          error={Boolean(formik.errors.techStack)}
          helperText={
            formik.errors.techStack ||
            `${formik.values.techStack.trim().length}/50`
          }
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          minRows={5}
          name="appDescription"
          label="Description"
          placeholder="Enter Description"
          onChange={formik.handleChange}
          value={formik.values.appDescription}
          error={Boolean(formik.errors.appDescription)}
          helperText={
            formik.errors.appDescription ||
            `${formik.values.appDescription.trim().length}/500`
          }
        />
      </Grid>
    </Grid>
  );
}
